import React, { useCallback, useEffect, useState } from 'react'
import uuid from 'react-uuid';
import ApiService from '../../../Services/ApiService';
import AlertService from '../../../Services/alertService';
import { useDispatch, useSelector } from 'react-redux';
import { addButtonSpinner, removeButtonSpinner } from '../../../store/actions';
import HtmlHead from '../../../components/HtmlHead/HtmlHead';
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Input,
  Label,
  Row,
  UncontrolledAlert,
} from "reactstrap"
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner';
import { fieldLengths } from '../../../Constants/MainKeys';
import ActionButton from '../../../components/Buttons/ActionButton';
import ReactSelectOption from '../../../components/SelectOptions/ReactSelectOption';
import MainService from '../../../Services/MainService';
import CloudflareCaptchaComponent from './../../../components/CloudflareCaptchaComponent/CloudflareCaptchaComponent';

const buttonSpinnerId = uuid();

export default function CustomerSupport(props) {

  const dispatch = useDispatch();
  const businessTypes = [
    {
      id: 1,
      name: "Merchant",
    },
    {
      id: 2,
      name: "Paying Customer",
    },
    {
      id: 3,
      name: "Other",
    },
  ]

  const title = "Customer Support";
  const description = "";
  const { language } = useSelector(state => state.Languages);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { user } = useSelector(state => state.Login);
  const [captchaToken, setCaptchaToken] = useState("");

  const [values, setValues] = useState({
    legalBusinessName: "",
    businessTypeId: null,
    firstName: user?.firstname || "",
    lastName: user?.lastname || "",
    email: user?.email || "",
    message: "",
  });

  const resetForm = () => {
    setValues({
      legalBusinessName: "",
      businessTypeId: null,
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    })
  }

  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);

  useEffect(() => {
    return () => {
      setIsInvalidSubmit(false);
    }
  }, [])

  const onChange = (event, fieldName, maxLength = null) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setValues((values) => ({
      ...values,
      [fieldName]: event.target.value,
    }));
    setIsInvalidSubmit(false);
  }

  const onSelectOptionChange = (item, fieldName) => {
    if (!item) { return false; }
    setValues(values => ({
      ...values,
      [fieldName]: item.value
    }))
    setIsInvalidSubmit(false);
  }

  const onSubmit = (event) => {
    event.preventDefault();
    let isInvalid = false;

    const {
      firstName,
      lastName,
      email,
      message,
      businessTypeId,
      legalBusinessName,
    } = values;

    if (!email.trim().length || !message.trim().length || !businessTypeId) {
      isInvalid = true;
    }
    if (businessTypeId === 1 && !values.legalBusinessName.trim().length) {
      isInvalid = true;
    }
    if (businessTypeId === 2 && (!values.firstName.trim().length || !values.lastName.trim().length)) {
      isInvalid = true;
    }
    if (businessTypeId === 3) {
      if ((values.firstName.trim().length && values.lastName.trim().length) || values.legalBusinessName.trim().length) {
      } else {
        isInvalid = true;
      }
    }
    if (isInvalid) {
      setIsInvalidSubmit(true);
      return;
    }
    const form = {
      legalBusinessName,
      businessTypeId,
      firstname: firstName,
      lastName: lastName,
      email,
      message,
      token: captchaToken,
    };
    setButtonSpinner(buttonSpinnerId);
    ApiService.sendContactUsData(form).then(() => {
      AlertService.alert("success", "Thank you! We've received your request. Our support team will follow up with you soon.")
      resetForm();
      props.history.push(`/${language}/tickets`)
    }).catch(error => getFail(error)).finally(() => {
      extractButtonSpinner(buttonSpinnerId);
    })
  }

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || "error"), error);
  };


  const onCheckBusinessNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 1 && !values.legalBusinessName.trim().length) {
        return "error-border"
      }
      if (values.businessTypeId === 3) {
        if (values.legalBusinessName.trim().length) {
          return ""
        } else {
          if (!values.firstName.trim().length && !values.lastName.trim().length) {
            return "error-border"
          }
        }
      }

    }
    return ""
  }

  const onCheckFirstNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 2 && !values.firstName.trim().length) {
        return "error-border"
      }
      if (values.businessTypeId === 3) {
        if (!values.firstName.trim().length && values.lastName.trim().length) {
          return "error-border"
        }
        if (!values.firstName.trim().length && !values.lastName.trim().length && values.legalBusinessName.trim().length) {
          return ""
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && !values.legalBusinessName.trim().length) {
          return "error-border"
        }
      }
    }
    return ""
  }

  const onCheckLastNameValidation = () => {
    if (isInvalidSubmit) {
      if (values.businessTypeId === 2 && !values.lastName.trim().length) {
        return "error-border"
      }
      if (values.businessTypeId === 3) {
        if (!values.lastName.trim().length && values.firstName.trim().length) {
          return "error-border"
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && values.legalBusinessName.trim().length) {
          return ""
        }
        if (!values.lastName.trim().length && !values.firstName.trim().length && !values.legalBusinessName.trim().length) {
          return "error-border"
        }
      }
    }
    return ""
  }

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);


  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className='container-fluid'>
          {/* <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Customer Support"
          /> */}
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Customer Support"
            isShowGoBackButton={true}
            goBack={() => window.history.back()}
          />
          <Row>
            <Col lg={12}>
              <UncontrolledAlert color={"info"} role="alert">
                <div className='mb-2'>
                  <span><b>Have questions?</b></span>
                  <br />
                  <span>Don't hesitate to reach out.</span>
                </div>
                <div>
                  <span>We're here to resolve any issues and answer any questions you may have. Feel free to also check&nbsp;</span>
                  <a
                    className='underline'
                    style={{ display: "inline-block" }}
                    href={`https://cryllex.${MainService.getUrlExtension()}/faq`}
                    target='_blank'
                  >
                    <p className='m-0 me-2 '>Cryllex's FAQ</p>
                  </a>
                  <span>page for insights that others have frequently requested!</span>
                  <br />
                  <span>Submit the Customer Support Ticket and a representative will get back to you shortly.</span>
                </div>
              </UncontrolledAlert>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>
                        Customer Support
                      </span>
                    </div>
                    <hr />
                  </CardTitle>



                  <form onSubmit={onSubmit}>
                    <Row className='mb-3'>
                      <Col sm={12}>
                        <Row>
                          <Col md={4} className='mb-3'>
                            <Label htmlFor='legalBusinessName' className='mb-1 cursor-pointer'>Legal Business Name</Label>
                            <Input
                              id="legalBusinessName"
                              type="text"
                              placeholder='e.g. Skyline Ventures'
                              className={`form-control ${onCheckBusinessNameValidation()}`}
                              value={values.legalBusinessName}
                              onChange={(event) => onChange(event, "legalBusinessName", fieldLengths.length_120)}
                            />
                          </Col>
                          <Col md={4} className='mb-3'>
                            <Label htmlFor='firstname' className='mb-1 cursor-pointer'>Customer Type</Label>
                            <ReactSelectOption
                              value={values.businessTypeId}
                              className={`w-100 ${isInvalidSubmit && !values.businessTypeId ? "error-border" : ""}`}
                              isInvalidSubmit={isInvalidSubmit}
                              selectedValue={(() => {
                                const selectedValue = { ...businessTypes.find(data => data.id === values.businessTypeId) };
                                if (Object.keys(selectedValue).length) {
                                  selectedValue.label = selectedValue.name;
                                  selectedValue.value = selectedValue.id;
                                  return selectedValue;
                                } else {
                                  return { label: "Customer Type", value: null }
                                }
                              })()}
                              items={businessTypes.map(data => ({ label: data.name, value: data.id }))}
                              onChange={(item) => onSelectOptionChange(item, "businessTypeId")}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={12}>
                        <Row>
                          <Col md={4} className='mb-3'>
                            <Label htmlFor='firstname' className='mb-1 cursor-pointer'>First Name</Label>
                            <Input
                              id="firstName"
                              type="text"
                              placeholder='e.g. John'
                              className={`form-control ${onCheckFirstNameValidation()}`}
                              value={values.firstName}
                              onChange={(event) => onChange(event, "firstName", fieldLengths.length_120)}
                            />
                          </Col>
                          <Col md={4} className='mb-3'>
                            <Label htmlFor='lastName' className='mb-1 cursor-pointer'>Last Name</Label>
                            <Input
                              id="lastName"
                              type="text"
                              placeholder='e.g. Smith'
                              className={`form-control ${onCheckLastNameValidation()}`}
                              value={values.lastName}
                              onChange={(event) => onChange(event, "lastName", fieldLengths.length_120)}
                            />
                          </Col>
                          <Col md={4} className='mb-3'>
                            <Label htmlFor='email' className='mb-1 cursor-pointer'>Email Address</Label>
                            <Input
                              id="email"
                              type="email"
                              placeholder='e.g. johnsmith@gmail.com'
                              className={`form-control ${isInvalidSubmit && !values.email ? "error-border" : ""}`}
                              value={values.email}
                              onChange={(event) => onChange(event, "email", fieldLengths.length_120)}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={12}>
                        <Label htmlFor='rejectMessage'>Message</Label>
                        <Input
                          id="rejectMessage"
                          type="textarea"
                          value={values.message}
                          rows={4}
                          style={{ resize: "none" }}
                          placeholder='Type message...'
                          className={`form-control ${(isInvalidSubmit && !values.message.trim().length) ? "error-border" : ""}`}
                          onChange={(event) => onChange(event, "message", fieldLengths.length_2000)}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <div className='my-2 d-flex justify-content-end'>
                      <CloudflareCaptchaComponent cb={setCaptchaToken} />
                    </div>
                    <div className='d-flex justify-content-end'>
                      <ActionButton
                        type="submit"
                        name="Submit"
                        className="shadow-sm px-4 mt-21 btn btn-primary"
                        spinnerId={buttonSpinnerId}
                        disabled={!captchaToken}
                      />
                    </div>

                  </form>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div >
    </>
  )
}
